import { useCallback, useEffect } from 'react'

import { PubSubManager } from './PubSubManager'

export interface PubSubVariables<T> {
  topic: string
  onMessage?(body: T): any
}

export function usePubSub<T>({ topic, onMessage }: PubSubVariables<T>): void {
  const pubSubManager: PubSubManager = PubSubManager.getInstance()

  const disconnect = useCallback(() => {
    pubSubManager.unsubscribeTopic(topic)
  }, [pubSubManager, topic])

  const handleOnMessage = useCallback(
    (data: T) => {
      if (data && onMessage) {
        onMessage(data)
      }
    },
    [onMessage]
  )

  useEffect(() => {
    pubSubManager.subscribeTopic(topic, handleOnMessage)
  }, [handleOnMessage, pubSubManager, topic])

  // called on destroy component
  useEffect(() => () => disconnect(), [disconnect])
}
